import { setNewsFilters, useNewsFilters } from "modules/NewsDashboard/components/NewsDashboardFilters/hooks";
import { NEWS_STORAGE_KEYS } from "modules/NewsDashboard/storageKeys";
import { setPreference } from "utils/common";

import type { OnChangeFn, PaginationState } from "@tanstack/react-table";
import type { PAGE_SIZE } from "utils/common";

export const useNewsDashboardTableHandlers = () => {
  const newsFilters = useNewsFilters();

  const handlePaginationChange: OnChangeFn<PaginationState> = updater => {
    const newState = typeof updater === "function" ? updater({ pageIndex: newsFilters.page - 1, pageSize: newsFilters.page_size }) : updater;
    setNewsFilters({ ...newsFilters, page: newState.pageIndex + 1 });
  };

  const handlePageSizeChange = (value: PAGE_SIZE) => {
    setPreference(NEWS_STORAGE_KEYS.PageSizePreference, value);
    setNewsFilters({ ...newsFilters, page_size: value, page: 1 });
  };

  return { handlePageSizeChange, handlePaginationChange };
};
